/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppConfiguration } from './AppConfiguration';
import {
    AppConfigurationFromJSON,
    AppConfigurationFromJSONTyped,
    AppConfigurationToJSON,
} from './AppConfiguration';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';
import type { Session } from './Session';
import {
    SessionFromJSON,
    SessionFromJSONTyped,
    SessionToJSON,
} from './Session';

/**
 * 
 * @export
 * @interface AppState
 */
export interface AppState {
    /**
     * 
     * @type {AppConfiguration}
     * @memberof AppState
     */
    appConfiguration?: AppConfiguration;
    /**
     * 
     * @type {Page}
     * @memberof AppState
     */
    page?: Page;
    /**
     * 
     * @type {Session}
     * @memberof AppState
     */
    session?: Session;
}

/**
 * Check if a given object implements the AppState interface.
 */
export function instanceOfAppState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppStateFromJSON(json: any): AppState {
    return AppStateFromJSONTyped(json, false);
}

export function AppStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appConfiguration': !exists(json, 'appConfiguration') ? undefined : AppConfigurationFromJSON(json['appConfiguration']),
        'page': !exists(json, 'page') ? undefined : PageFromJSON(json['page']),
        'session': !exists(json, 'session') ? undefined : SessionFromJSON(json['session']),
    };
}

export function AppStateToJSON(value?: AppState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appConfiguration': AppConfigurationToJSON(value.appConfiguration),
        'page': PageToJSON(value.page),
        'session': SessionToJSON(value.session),
    };
}

